import { Component, inject, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  MatPaginatorModule,
} from '@angular/material/paginator';
import { Dataset, ItemListResponse, Record } from '@models';
import { RecordItemComponent } from '../item/item.component';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { httpResource } from '@angular/common/http';
import { environment } from '@environment';
import { ListComponent } from '@components/list/list.component';

@Component({
  selector: 'app-record-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  imports: [CommonModule, MatPaginatorModule, MatListModule, MatIconModule, ListComponent],
})
export class RecordListComponent {
  private dialog = inject(MatDialog);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  dataset = signal<Dataset>(this.route.snapshot.parent!.data['dataset']);

  page = signal(parseInt(this.route.snapshot.queryParams['page']) || 0);
  pageSize = signal(parseInt(this.route.snapshot.queryParams['pageSize']) || 10);
  records = httpResource<ItemListResponse<Record>>(() => `${environment.kinkoHost}/dataset/${this.dataset().id}/record/?skip=${this.page() * this.pageSize()}&take=${this.pageSize()}&order=created:desc&count=true&parentId=`);

  constructor() {
    this.route.queryParams.subscribe((params: Params) => {
      this.page.set(parseInt(params['page']) || 0);
      this.pageSize.set(parseInt(params['pageSize']) || 10);
    });
  }

  filter(pageIndex: number, pageSize: number) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        page: pageIndex || undefined,
        pageSize: pageSize === 10 ? undefined : pageSize,
      },
      replaceUrl: true
    });
  }

  openRecord(record: Record): void {
    this.dialog.open(RecordItemComponent, {
      data: record,
      minWidth: '360px',
      width: '480px',
    });
  }
}
